import { SCHEDULE_FILTER_COUNT_ZERO, SCHEDULE_FILTER_KEY } from './ScheduleFilterChips.constants';
import { hasClientsWaitingSchedule } from './scheduleClientsWaiting';

const MIN_CLASSPASS_BOOKED = 1;

function hasClasspassReservations({ spots = {} } = {}) {
  return (spots.classpassBooked || SCHEDULE_FILTER_COUNT_ZERO) >= MIN_CLASSPASS_BOOKED;
}

export function filterSchedulesByScheduleFilterKey(schedules = [], filterKey, { hasSpotManagePermission = true } = {}) {
  switch (filterKey) {
    case SCHEDULE_FILTER_KEY.ACTIVE_CLASSES:
      return schedules.filter(({ isDisabled }) => !isDisabled);
    case SCHEDULE_FILTER_KEY.WITH_RESERVATIONS:
      return schedules.filter(hasClasspassReservations);
    case SCHEDULE_FILTER_KEY.WITH_CLIENTS_WAITING:
      return schedules.filter(schedule => hasClientsWaitingSchedule(schedule, { hasSpotManagePermission }));
    case SCHEDULE_FILTER_KEY.DISABLED_CLASSES:
      return schedules.filter(({ isDisabled }) => isDisabled);
    case SCHEDULE_FILTER_KEY.WITH_NEW_CLIENTS:
      return schedules;
    default:
      return schedules;
  }
}
